import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { History } from "lucide-react";
import { formatCoinPoolCoin, COIN_SIDE_LABEL, getLocalDayBounds } from "../../utils/coinPoolHelpers";
import { sideLabel } from "../../utils/coinFlipHelpers";
import { truncateHash } from "../../utils/coinFairHelpers";
import {
  fetchCoinPoolHistory,
  selectCoinPoolHistory,
  selectCoinPoolHistoryTotal,
} from "../../redux/coinPoolSlice";
import {
  fetchCoinFlipHistory,
  selectCoinFlipHistory,
} from "../../redux/coinFlipSlice";

const formatWhen = (value) => {
  if (!value) return "";
  const d = new Date(value);
  if (Number.isNaN(d.getTime())) return "";
  return d.toLocaleString(undefined, {
    month: "short",
    day: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  });
};

const BondCoinHistoryList = ({ game = "pool", limit = 8 }) => {
  const dispatch = useDispatch();
  const poolHistory = useSelector(selectCoinPoolHistory);
  const poolHistoryTotal = useSelector(selectCoinPoolHistoryTotal);
  const flipHistory = useSelector(selectCoinFlipHistory);
  const rows = game === "flip" ? flipHistory : poolHistory;
  const count = game === "flip" ? rows.length : poolHistoryTotal;

  useEffect(() => {
    if (game === "flip") dispatch(fetchCoinFlipHistory({ limit }));
    else dispatch(fetchCoinPoolHistory({ limit, ...getLocalDayBounds() }));
  }, [dispatch, game, limit]);

  return (
    <section className="bcoin-panel-section bcoin-history-section">
      <header className="bcoin-panel-section-head">
        <span className="bcoin-panel-section-title">
          <History size={13} strokeWidth={2.5} />
          {game === "flip" ? "Recent rounds" : "Today"}
        </span>
        <span className="bcoin-panel-section-count">{count}</span>
      </header>

      {rows.length === 0 ? (
        <div className="bcoin-panel-empty compact">
          <History size={18} strokeWidth={2} />
          <p>{game === "flip" ? "No settled rounds yet" : "None today"}</p>
          {game === "flip" ? (
            <span>Completed flips will appear here with provably fair hashes.</span>
          ) : null}
        </div>
      ) : (
        <ul className="bcoin-history-list">
          {rows.map((row) => (
            <li key={row.id} className="bcoin-history-row">
              <div className="bcoin-history-main">
                <strong>
                  {game === "flip"
                    ? `${sideLabel(row.playerSide)} → ${sideLabel(row.outcome)}`
                    : COIN_SIDE_LABEL[row.outcome] || row.outcome || row.status}
                </strong>
                <span>{formatWhen(row.settledAt)}</span>
              </div>
              <div className="bcoin-history-meta">
                {game === "flip" ? (
                  <span>
                    {formatCoinPoolCoin(row.stake)} COIN · {row.status}
                  </span>
                ) : (
                  <span>{formatCoinPoolCoin(row.totalStaked)} pool</span>
                )}
                {row.seedHash ? (
                  <span className="bcoin-fair-mono" title={row.seedHash}>
                    {truncateHash(row.seedHash)}
                  </span>
                ) : null}
              </div>
            </li>
          ))}
        </ul>
      )}
    </section>
  );
};

export default BondCoinHistoryList;
